import { Runinstance } from "src/models/runInstance";
import { createEntityModel } from "src/store/models/entity/_shared";

export const RunInstanceEntityModel = createEntityModel<Runinstance>();
